let cachedEnv;
export function detectEnvironment() {
    if (cachedEnv) {
        return cachedEnv;
    }
    try {
        if (typeof navigator === 'object' && navigator?.userAgent === 'Cloudflare-Workers') {
            cachedEnv = 'cf-worker';
            return cachedEnv;
        }
        if (typeof window !== 'undefined' && typeof window['document'] !== 'undefined') {
            if (typeof navigator === 'object' && navigator?.userAgent?.includes('jsdom')) {
                cachedEnv = 'jsdom';
                return cachedEnv;
            }
            cachedEnv = 'browser';
            return cachedEnv;
        }
        // Check for a Node.js environment
        if (typeof process !== 'undefined' && process.versions?.node) {
            cachedEnv = 'node';
            return cachedEnv;
        }
        // Check for worker-like environments (Cloudflare Workers, Vercel Edge, etc.)
        if (typeof globalThis !== 'undefined' &&
            typeof globalThis.addEventListener === 'function' &&
            typeof globalThis.Request === 'function') {
            // Vercel Edge runtime sets a global variable "EdgeRuntime" equal to "edge"
            if ('EdgeRuntime' in globalThis && globalThis.EdgeRuntime === 'edge') {
                cachedEnv = 'vercel-edge';
                return cachedEnv;
            }
            if (typeof WebSocket !== 'undefined') {
                // Assume a worker environment like Cloudflare Workers
                cachedEnv = 'cf-worker';
                return cachedEnv;
            }
        }
    }
    catch {
        console.warn('Failed to detect environment');
        /* empty */
    }
    // Fallback for environments that don't match any of the above
    cachedEnv = 'unknown';
    return cachedEnv;
}
export function isBrowser() {
    const env = detectEnvironment();
    return env === 'browser' || env === 'jsdom';
}
//# sourceMappingURL=environment.js.map